import ActionTypes from '../constants/ActionTypes';
import { createAction } from 'redux-actions';
import { postFeedback } from '../api/feedback';
import Socium from '../constants/Socium';
import Cookies from 'universal-cookie';

export const submitFeedback = async (comment, satisfied, jobAssignmentId) => {
  return async dispatch => {
    dispatch(createAction(ActionTypes.FEEDBACK_REQUEST)());
    const cookies = new Cookies();

    try {
      await postFeedback(
        {
          comment,
          questionId: 7,
          answerId: satisfied ? 20 : 21,
          jobAssignmentId
        },
        cookies.get(Socium.COOKIE_TOKEN) || ''
      );

      dispatch(createAction(ActionTypes.FEEDBACK_SUCCESS)());
      return;
    } catch (e) {
      const { data } = e.response;
      dispatch({
        type: ActionTypes.FEEDBACK_ERROR,
        payload: data
      });
      return;
    }
  };
};

export default {
  submitFeedback
};
